import axiosInstance from "./axiosInstance";

export const privateChatService = {
  // Get chat history between two users
  getChatHistory: async (otherStudentId, pageNumber = 1, pageSize = 50) => {
    try {
      const response = await axiosInstance.get(
        `/PrivateChat/history/${otherStudentId}?pageNumber=${pageNumber}&pageSize=${pageSize}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching private chat history:", error);
      throw error;
    }
  },

  // Send a private message
  sendMessage: async (toStudentId, message, imageUrl = null, videoUrl = null, audioUrl = null, replyToMessageId = null) => {
    try {
      const response = await axiosInstance.post("/PrivateChat/send", {
        ToStudentId: toStudentId,
        Message: message,
        ImageUrl: imageUrl,
        VideoUrl: videoUrl,
        AudioUrl: audioUrl,
        ReplyToMessageId: replyToMessageId,
      });
      return response.data;
    } catch (error) {
      console.error("Error sending private message:", error);
      throw error;
    }
  },

  // Delete a private message
  deleteMessage: async (messageId) => {
    try {
      const response = await axiosInstance.delete(`/PrivateChat/message/${messageId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting private message:", error);
      throw error;
    }
  },

  // Update/edit a private message
  updateMessage: async (messageId, message) => {
    try {
      const response = await axiosInstance.put(`/PrivateChat/message/${messageId}`, {
        Message: message,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating private message:", error);
      throw error;
    }
  },

  // Mark message as delivered
  markAsDelivered: async (messageId) => {
    try {
      const response = await axiosInstance.post(`/PrivateChat/message/${messageId}/delivered`);
      return response.data;
    } catch (error) {
      console.error("Error marking message as delivered:", error);
      throw error;
    }
  },

  // Mark message as read
  markAsRead: async (messageId) => {
    try {
      const response = await axiosInstance.post(`/PrivateChat/message/${messageId}/read`);
      return response.data;
    } catch (error) {
      console.error("Error marking message as read:", error);
      throw error;
    }
  },

  // Mark all messages in a conversation as read
  markAllAsRead: async (otherStudentId) => {
    try {
      const response = await axiosInstance.post(`/PrivateChat/conversation/${otherStudentId}/mark-all-read`);
      return response.data;
    } catch (error) {
      console.error("Error marking all messages as read:", error);
      throw error;
    }
  },

  // Get unread message count
  getUnreadCount: async (fromStudentId) => {
    try {
      const response = await axiosInstance.get(`/PrivateChat/unread-count/${fromStudentId}`);
      return response.data;
    } catch (error) {
      console.error("Error getting unread count:", error);
      throw error;
    }
  },

  // Upload image
  uploadImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post("/PrivateChat/upload-image", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  },

  // Upload video
  uploadVideo: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post("/PrivateChat/upload-video", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error uploading video:", error);
      throw error;
    }
  },

  // Upload audio/voice
  uploadAudio: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post("/PrivateChat/upload-audio", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error uploading audio:", error);
      throw error;
    }
  },
};

export default privateChatService;
